import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HuntingDistrictFormComponent } from './hunting-district-form/hunting-district-form.component';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class TemporalService {
  huntingDistrictId$ = new BehaviorSubject<string>(undefined)
  huntingDistrictForm$ = new BehaviorSubject<any>(undefined)

  previousUrl: string | null = null;
  currentUrl: string | null = null;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }


  setData(calledFrom:any, data:any, id){
    switch (calledFrom) {
      case HuntingDistrictFormComponent: {
        this.huntingDistrictId$.next(id)
        this.huntingDistrictForm$.next(data)
        break;
      }
    }
  }

  getData(calledFrom:any, data:any, id){
    switch (calledFrom) {
      case HuntingDistrictFormComponent: {
        return { huntingDistrictId: this.huntingDistrictId$.value, huntingDistrictForm: this.huntingDistrictForm$.value}
        break;
      }
    }
  }

  clearData(calledFrom:any){
    switch (calledFrom) {
      case HuntingDistrictFormComponent: {
        this.huntingDistrictId$.next(undefined)
        this.huntingDistrictForm$.next(undefined)
        break;
      }
    }
  }
}
